import * as style from './Faq.css';

import { IFaqItem } from 'shared/types/faq';
import { faqOwnerData } from 'shared/constants/faqOwner';
import { useDeviceType } from '@cian/ui-kit';
import classnames from 'classnames';
interface IFaqProps {
  Item: React.FC<IFaqItem>;
}

export const Faq: React.FC<IFaqProps> = ({ Item }) => {
  const device = useDeviceType();

  return (
    <div id="more" className={classnames(style['wrapper'], device === 'phone' && style['wrapper-phone'])}>
      <h2 className={style['title']}>Вопросы</h2>
      <div className={style['list']}>
        {faqOwnerData.map(item => (
          <Item {...item} key={item.id} />
        ))}
      </div>
    </div>
  );
};
